import { render, staticRenderFns } from "./raskAdd.vue?vue&type=template&id=d1281bd0&scoped=true&"
import script from "./raskAdd.vue?vue&type=script&lang=js&"
export * from "./raskAdd.vue?vue&type=script&lang=js&"
import style0 from "./raskAdd.vue?vue&type=style&index=0&id=d1281bd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1281bd0",
  null
  
)

export default component.exports